<route>
{
    "name": "admin-configuration-index",
    "meta": {
        "title": "Configuratii",
        "requiresAuth": true,
        "permissions": ["manager"],
        "fail": "/403"
    }
}
</route>
<template>
  <company-layout>
      <v-container fluid grid-list-xl>
          <v-row>
              <v-col>
                  <index></index>
              </v-col>
          </v-row>
      </v-container>
  </company-layout>
</template>

<script>
import CompanyLayout from "Layouts/Company.vue";
import Index from 'Components/workstations/Index'

export default {
    components: {
        CompanyLayout,
        Index
    }
};
</script>
